export enum CONTENT_LISTS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=7244334
     */
    TITLE_PAGE = 'ADMIN.NAV.CUSTOM_CONTENT_TYPE_LISTS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452232
     */
    REMOVE_MODULE = 'ADMIN_MODULE_MODULE_DELETE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452233
     */
    REMOVE_MODULE_DESCRIPTION = 'ADMIN_MODULE_MODULE_DELETE_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452234
     */
    DELETE_SUCCESS = 'ADMIN_MODULE_MODULE_DELETE_SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=258933435
     */
    CONTENT_TYPE_LISTS_FROM_YOUR_SITE = 'CONTENT_LISTS.CONTENT_TYPE_LISTS_FROM_YOUR_SITE',
}
